import { Component } from '@angular/core';
import { MainTemplate } from '../../models';
import { StyleService, TemplateService } from '../../services';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import customMatIcons from "../../../assets/images/custom-svg.json";

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent {
  public mainTemplate$: Observable<MainTemplate>;

  public customIcons: string[];

  constructor(
    public readonly styleService: StyleService,
    private readonly templateService: TemplateService,
    private readonly router: Router
  ) {
    this.mainTemplate$ = this.templateService.templateData$();
    this.customIcons = customMatIcons["imageNames"];
  }

  public goToPage(index: number): void {
    this.router.navigate(['/template/' + index]);
  }
}
